import { useFeatureFlagEnabled } from 'posthog-js/react';

/** The Instantly rollout flag; the API gates on the same key. */
export const INSTANTLY_FLAG = 'instantly_v1';

/** Whether Instantly is rolled out to the org: fail closed, so every
 *  Instantly surface stays hidden while the flags load. */
export function useInstantlyEnabled(): boolean {
  return useFeatureFlagEnabled(INSTANTLY_FLAG) === true;
}
